import { actionTypes } from "../actions/meetings";

const variable = (state = null, action) => {
  switch (action.type) {
    case actionTypes.FETCH_MEETING:
      return action.payload;
    default:
      return state;
  }
};

export default variable;